import { type ContextMenuList } from '../types/context-menu-list.type';

export const defaultMenuList: Array<ContextMenuList> = [];
